import { render, staticRenderFns } from "./AttributeList.vue?vue&type=template&id=39cc42a6&scoped=true&"
import script from "./AttributeList.vue?vue&type=script&lang=ts&"
export * from "./AttributeList.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeList.vue?vue&type=style&index=0&id=39cc42a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cc42a6",
  null
  
)

export default component.exports